import axios from 'axios'
import { BaseService } from '../base.service'
import {
  siteDto,
  pageDto,
  contactFormDto,
  ecommerceBlocksDto,
  termsContentDto,
  faqsBySection,
  securitiCookieConsent,
} from './content.dtos'
import { publicConfig } from '~/config/public'
import logRequests from '~/lib/axiosUtils'
import { ContactForm } from '~/lib/models/contact'

class ContentService extends BaseService {
  readonly client

  constructor() {
    super()
    this.client = axios.create({
      baseURL: isCypressSpecialBehaviour()
        ? 'http://localhost:3601/api'
        : publicConfig.services.content.url,
    })
    logRequests('content', this.client)
  }

  async getSiteByDomain(domain: string) {
    const res = await this.request({ url: '/sites/by-domain', params: { q: domain } }, siteDto)
    return res
  }

  async getPageByPath(site: number, path: string) {
    const res = await this.request({ url: '/pages/by-path', params: { q: path, site } }, pageDto)
    return res
  }

  async getEcommerceBlocksBySite(site: number) {
    const res = await this.request(
      { url: '/ecommerce-blocks/by-site', params: { site } },
      ecommerceBlocksDto
    )
    return res
  }

  async sendContactForm(contactFormBlockId: number, data: ContactForm, token?: string) {
    const domain = useSiteDomain()
    const res = await this.request(
      {
        method: 'POST',
        url: `/form-submission/contact/${contactFormBlockId}`,
        data,
        headers: {
          'X-strapi-turnstile': token,
          'X-turnstile-host': domain,
        },
      },
      contactFormDto
    )
    return res
  }

  async getTermsByDomain(domain: string) {
    try {
      const { content } = await this.request(
        { url: '/sites/terms/by-domain', params: { q: domain } },
        termsContentDto
      )
      return content
    } catch (error) {
      return ''
    }
  }

  async getFaqsBySection(domain: string, section: string) {
    try {
      const { content } = await this.request(
        { url: '/sites/faqs-by-section', params: { domain, section } },
        faqsBySection
      )
      return content ?? []
    } catch (error) {
      return []
    }
  }

  async getSecuritiCookieConsent(domain: string, project: string) {
    return await this.request(
      {
        url: '/sites/securiti-cookie-consent',
        params: {
          domain,
          project,
        },
      },
      securitiCookieConsent
    )
  }
}

export const contentService = new ContentService()
